import styled from "styled-components";
import { Grid } from "@material-ui/core";

export const STGrid = styled(Grid)`
  && {
    display: flex;
    height: 100%;
    padding-bottom: 16px;
    align-items: center;
  }
`;
